import { jsx as s } from "react/jsx-runtime";
import { useContext as y, createContext as v, useState as w, useEffect as N, Children as x } from "react";
import { cx as u } from "../apps/ui/styled-system/css/cx.js";
import { css as a } from "../apps/ui/styled-system/css/css.js";
const g = v(void 0);
function h({
  src: i,
  fallback: r,
  size: t,
  border: e,
  alt: d,
  title: m,
  className: n,
  children: o,
  ...c
}) {
  const l = y(g), [f, p] = w(!1);
  return N(() => p(!1), []), t ?? (t = (l == null ? void 0 : l.size) ?? "medium"), typeof t == "string" && (t = h.sizes[t]), e ?? (e = (l == null ? void 0 : l.border) ?? !1), typeof e == "boolean" && (e = e ? t <= 16 ? 1 : t <= 20 ? 2 : 3 : 0), /* @__PURE__ */ s(
    "div",
    {
      className: u(
        a({
          background: "var(--background-color-th_badge)",
          borderRadius: "50%",
          display: "grid",
          overflow: "hidden",
          placeItems: "center"
        }),
        n
      ),
      style: {
        height: t,
        width: t
      },
      title: m,
      children: o ? /* @__PURE__ */ s(
        "div",
        {
          className: a({
            display: "grid",
            placeItems: "center"
          }),
          style: {
            height: t - e * 2,
            width: t - e * 2
          },
          children: o
        }
      ) : (f || !i) && r && typeof r != "string" ? /* @__PURE__ */ s(
        "div",
        {
          className: a({
            display: "grid",
            placeItems: "center"
          }),
          style: {
            height: t - e * 2,
            width: t - e * 2
          },
          children: r
        }
      ) : i ? /* @__PURE__ */ s(
        "img",
        {
          alt: d,
          className: a({
            display: "block"
          }),
          height: t - e * 2,
          onError: () => p(!0),
          src: f && typeof r == "string" ? r : i,
          width: t - e * 2,
          ...c
        }
      ) : null
    }
  );
}
((i) => {
  i.sizes = {
    large: 38,
    medium: 24,
    small: 16
  };
  function r({
    border: t = !0,
    children: e,
    className: d,
    gap: m,
    size: n = "medium"
  }) {
    return typeof n != "number" && (n = i.sizes[n]), m ?? (m = n * -0.3), /* @__PURE__ */ s(g.Provider, { value: { border: t, size: n }, children: /* @__PURE__ */ s(
      "div",
      {
        className: u(
          a({
            alignItems: "center",
            display: "flex"
          }),
          d
        ),
        children: x.map(e, (o, c) => /* @__PURE__ */ s("div", { style: { marginLeft: c === 0 ? 0 : m }, children: o }))
      }
    ) });
  }
  i.Stack = r;
})(h || (h = {}));
export {
  h as DiscIcon
};
//# sourceMappingURL=DiscIcon.js.map
